import React from "react";
import "./styles.css";
import { useNavigate } from "react-router-dom";
import { EditModelIcon, DeleteIcon, ArrowDownIcon } from "../../../Assets/images/svgs";
import { ellipsisify } from "../../../Library/helpers";
import { Tooltip } from "@chakra-ui/react";
import { getLocalisedDate, getLocalisedTime } from "../../../Library/datetime";

const DetailBar = ({ data = [], config, showEditDelete = false, handleEditClick = () => {}, handleDelete = () => {}, search, headers, isGeofence, handleSorting }) => {
  const navigate = useNavigate();
  const [sortConfig, setSortConfig] = React.useState({ key: "", direction: "asc" });

  const renderAlertDetails = (config, obj) => {
    return config.map(({ type, key, label, linkText, subKey }) => {
      if (type === "kv") {
        return (
          <div className="detail-bar-kv-box detail-bar-box" key={key}>
            <Tooltip label={(`${((obj[key] || obj[subKey]) || "-")}`).length > 20 ? ((obj[key] || obj[subKey]) || "-") : ""}>
              <span className="detail-bar-val">{ellipsisify(`${((obj[key] || obj[subKey]) || "-")}`, 20)}</span>
            </Tooltip>
          </div>
        );
      }
      if (type === "link") {
        return (
          <div className="detail-bar-link-cnt detail-bar-box" key={key}>
            <span className="detail-bar-link" onClick={() => navigate("")}>
              {linkText}({obj[key]})
            </span>
          </div>
        );
      }

      if (type === "ts") {
        return (
          <div className="detail-bar-kv-box detail-bar-box" key={key}>
            <span className="detail-bar-key">
              {obj[key] ? (
                <div className="date-container">
                  <p>{getLocalisedDate(obj[key] || 0)}</p>
                  <p>{getLocalisedTime(obj[key] || 0)}</p>
                </div>
              ) : "-"}
            </span>
          </div>
        );
      }
      return null;
    });
  };

  const handleSort = (key) => {
    const direction = sortConfig.key === key && sortConfig.direction === "asc" ? "desc" : "asc";
    setSortConfig({ key, direction });
    if (handleSorting) handleSorting(key, direction);
  };

  const renderAlertColumns = () => {
    return (
      <div className={`detail-bar header ${!isGeofence ? "overspeed" : ""}`}>
        {headers.map((header, i) => (
          <span key={i} onClick={() => header.sort && handleSort(header.key)} className={`detail-bar-key ${header.sort ? "cursor" : ""}`}>
            {header.nm}
            {sortConfig.key === header.key ? (
              <>
                <ArrowDownIcon className={`${sortConfig.direction === "asc" ? "rotate-arrow" : ""}`} />
              </>
            ) : null}
          </span>
        ))}
      </div>
    );
  }

  return data && data.length ? (
    <>
      {renderAlertColumns()}
      <div className="geofence-scroll">
        {data.map((obj, index) => (
          <div className={`detail-bar ${!isGeofence ? "overspeed" : ""}`} key={index}>
            {renderAlertDetails(config, obj)}
            {
              showEditDelete ?
              <div className="detail-bar-btn-cnt detail-bar-box">
                <EditModelIcon className="detail-bar-icon detail-bar-edit-icon" onClick={() => handleEditClick(obj.idx)} />
                <DeleteIcon className="detail-bar-icon detail-bar-delete-icon" onClick={() => handleDelete(obj.idx, obj)} />
              </div> :
              null
            }
          </div>
        ))}
      </div>
    </>
  ) : (
    <div className="detail-bar-no-data">
      <span className="detail-bar-no-data-text">{search ? "No geofences match your search" : "You haven't added any geofences yet"}</span>
    </div>
  );
};

export default DetailBar;
